import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CustomIcon from '../common/CustomIcon';

import * as bookActions from '../../actions/bookActions';
import * as messageAlert from '../../actions/messageAlertAction';
import { ANALYTICS_CONTEXT } from '../../types/analytics';

class NewUnitCard extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.createUnitFromScratch = this.createUnitFromScratch.bind(this);
  }

  static propTypes = {
    openPosition: PropTypes.number,
    position: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    bookActions: PropTypes.any,
    isAppOnline: PropTypes.any,
    isComplete: PropTypes.any,
    idBook: PropTypes.any,
    idClassroom: PropTypes.any,
    hideCreateUnitButton: PropTypes.bool
  };

  createUnitFromScratch() {
    const { isAppOnline } = this.props;
    if (isAppOnline) {
      const { bookActions, position, idBook, idClassroom } = this.props;
      const newPosition = position;
      bookActions.addNewUnit(idBook, idClassroom, newPosition, undefined, undefined, ANALYTICS_CONTEXT.UNIT_CREATE);
    }
  }

  /**
   * Renders the new unit button in each card
   * @returns {XML}
   */
  renderNewUnitButton() {
    const { openPosition, position, isComplete, onClick } = this.props;
    let createUnitContentVisibility = { visibility: isComplete ? 'visible' : 'hidden' };
    let createUnitContentClass = openPosition === position ? 'options selected' : 'options';

    let studentClass = !isComplete ? ' student' : '';

    let newUnitCss = (openPosition === position ? 'unit-card-new visible' : 'unit-card-new') + studentClass;

    return (
      <div className="unit-card-new-wrapper">
        <div ref={`unit-card-new ${position}inf`} className={newUnitCss}>
          <div className={createUnitContentClass} style={createUnitContentVisibility}>
            <div className="icon-wrapper" onClick={onClick || this.createUnitFromScratch}>
              <CustomIcon name="plus-addition-sign-circle" size={22} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.hideCreateUnitButton) {
      return null;
    }
    return <div>{this.renderNewUnitButton()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    openPosition: state.book.openNewUnit,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    hideCreateUnitButton: state.account.configuration.hideCreateUnitButton
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewUnitCard);
